import Papa from 'papaparse';
import { FlattenedConversation } from './dynamodb';

export const exportFlattenedConversationsToCSV = (
  conversations: FlattenedConversation[],
): void => {
  // Sort by question timestamp for better organization
  const sortedConversations = [...conversations].sort(
    (a, b) =>
      new Date(b.question_timestamp).getTime() -
      new Date(a.question_timestamp).getTime(),
  );

  // Convert to CSV
  const csv = Papa.unparse(sortedConversations, {
    header: true,
    columns: [
      'session_id',
      'user_id',
      'question',
      'answer',
      'formatted_question_time',
      'formatted_answer_time',
      'question_timestamp',
      'answer_timestamp',
    ],
  });

  // Create and download file
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    const now = new Date();
    const timestamp = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}`;
    link.setAttribute('download', `conversations_qa_${timestamp}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
